<template>
    <div class="body_main">
        <div class="body_bd">
            <!-- 搜索-->
            <el-form class="search_con" :model="queryOrderParams" ref="queryOrderParamsForm" :inline="true"
                     label-width="100px">
                <el-form-item label="就诊单号">
                    <el-input
                        v-model="queryOrderParams.serialNo"
                        placeholder="就诊单号"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="就诊单状态">
                    <el-select style="width: 120px" v-model="queryOrderParams.status" placeholder="就诊单状态">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="待支付" value="3"></el-option>
                        <el-option label="待配送" value="5"></el-option>
                        <el-option label="配送中" value="6"></el-option>
                        <el-option label="已完成" value="7"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="药剂类型" prop="billingType">
                    <el-select style="width: 120px" v-model="queryOrderParams.billingType" placeholder="药剂类型"
                               clearable>
                        <el-option label="全部" value=""></el-option>
                        <el-option label="颗粒" value="0"></el-option>
                        <el-option label="饮片" value="1"></el-option>
                        <el-option label="膏方" value="2"></el-option>
                        <el-option label="水丸" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="患者姓名">
                    <el-input
                        v-model="queryOrderParams.patientName"
                        placeholder="请输入患者姓名"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="患者身份证">
                    <el-input
                        v-model="queryOrderParams.identity"
                        placeholder="请输入患者身份证"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="患者手机号">
                    <el-input
                        v-model="queryOrderParams.phoneNumber"
                        placeholder="请输入患者手机号码"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="开方日期">
                    <el-date-picker
                        v-model="dateTime"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="YYYY-MM-DD"
                        @change="chooseDateTime($event)"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="Search" @click="getOrderList">搜索</el-button>
                    <el-button plain type="info" icon="RefreshLeft" @click="resetQuery">重置</el-button>
                </el-form-item>
            </el-form>

            <!-- 表格-->
            <div class="table_bd">
                <el-table
                    ref="multipleOrderTable"
                    v-loading="orderTableLoading"
                    :data="orderlist"
                    :height="orderTableHeight"
                    @row-dblclick="dbclickOpenOrderDetail"
                    style="width: 100%">
                    <template #empty>
                        <el-empty :image-size="120"></el-empty>
                    </template>
                    <el-table-column
                        label="就诊单号"
                        fixed
                        width="200px">
                        <template #default="scope">
                            <el-tag class="mrr5" size="small" effect="dark"
                                    :type="scope.row.orderSource === 'patient' || scope.row.orderSource === 'patientRepeat' ? 'warning' :
                                    scope.row.orderSource === 'doc' || scope.row.orderSource === 'docRepeat' ? 'success' : 'primary'"
                                    disable-transitions>{{
                                    scope.row.orderSource === 'patient' || scope.row.orderSource === 'patientRepeat' ? '患' :
                                        scope.row.orderSource === 'doc' || scope.row.orderSource === 'docRepeat' ? '医' : '门'
                                }}
                            </el-tag>
                            <el-tag class="mrr5" size="small" effect="light" :type="scope.row.isFree === '1' ? '' : 'info'"
                                    disable-transitions>{{ scope.row.isFree === '1' ? '普' : '科' }}
                            </el-tag>
                            <el-tag class="mrr5" size="small" effect="plain"
                                    v-if="scope.row.orderSource === 'patientRepeat' || scope.row.orderSource === 'docRepeat'"
                                    type="danger">复
                            </el-tag>
                            <el-tag class="mrr5" size="small" effect="light"
                                    :type="scope.row.billingType === '0' ? 'primary' : scope.row.billingType === '1' ? 'success' : scope.row.billingType === '2' ? 'warning' : 'danger'"
                                    disable-transitions>{{ scope.row.billingTypeName.substr(0, 1) }}
                            </el-tag>
                            <el-tag class="mrr5" size="small" type="success"
                                    v-if="scope.row.billingType === '1'&&scope.row.decoctType === '0'">自煎
                            </el-tag>
                            <el-tag class="mrr5" size="small" type="warning"
                                    v-if="scope.row.billingType === '1'&&scope.row.decoctType === '1'">代煎
                            </el-tag>
                            <br>
                            <span>{{ scope.row.serialNo === null ? '---' : scope.row.serialNo }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="患者姓名"
                        fixed
                        width="140px">
                        <template #default="scope">
                            <div class="base_con">
                                <el-image style="width: 32px;height: 32px;margin-right: 10px"
                                          :src="scope.row.patientAvatar"></el-image>
                                <div class="base_info">
                                        <span style="font-size: 14px; font-weight: 600; line-height: 22px">{{
                                                scope.row.patientName === null ? '---' : scope.row.patientName
                                            }}</span>
                                    <span style="font-size: 14px; color:#aaa; line-height: 24px">{{
                                            scope.row.patientSexText
                                        }} {{ scope.row.patientAge }}岁</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="160px"
                        label="手机号">
                        <template #default="scope">
                            <div class="span_con">
                                {{
                                    scope.row.patientPhone === null || scope.row.patientPhone === '' || scope.row.patientPhone === undefined ? '---' : scope.row.patientPhone
                                }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="160px"
                        label="身份证">
                        <template #default="scope">
                            <div class="span_con">
                                {{
                                    scope.row.identity === null || scope.row.identity === '' || scope.row.identity === undefined ? '---' : scope.row.identity
                                }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="120px"
                        label="订单状态">
                        <template #default="scope">
                            <div class="span_con">
                                <el-tag class="mrr5" size="small" :type="scope.row.status === '3' || scope.row.status === '4' || scope.row.status === '10' ? 'danger' :
                                scope.row.status === '1' || scope.row.status === '5' || scope.row.status === '6' || scope.row.status === '7' ? 'primary' :
                                scope.row.status === '2' || scope.row.status === '9' ? 'warning' :
                                scope.row.status === '7' ? 'success' : 'info'"
                                        disable-transitions>{{ getOrderStatus(scope.row.status) }}
                                </el-tag>

                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="280px"
                        label="诊断结果">
                        <template #default="scope">
                            <div class="span_con"
                                 :title="scope.row.clinicalDiagnosis === null ? '---' : scope.row.clinicalDiagnosis">
                                {{ scope.row.clinicalDiagnosis === null ? '---' : scope.row.clinicalDiagnosis }}
                            </div>
                        </template>
                    </el-table-column>
<!--                    <el-table-column-->
<!--                        width="120px"-->
<!--                        label="药方总重">-->
<!--                        <template #default="scope">-->
<!--                            <span>{{ parseFloat(scope.row.orderWeight).toFixed(2) }}g</span>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                    <el-table-column-->
<!--                        width="120px"-->
<!--                        label="药材费用">-->
<!--                        <template #default="scope">-->
<!--                            <span>￥{{-->
<!--                                    scope.row.medicalCountPrice === null || scope.row.medicalCountPrice === undefined ? '0.00' : scope.row.medicalCountPrice-->
<!--                                }}</span>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                    <el-table-column-->
<!--                        width="120px"-->
<!--                        label="加工费用">-->
<!--                        <template #default="scope">-->
<!--                            <span>￥{{-->
<!--                                    scope.row.processingCosts === null || scope.row.processingCosts === undefined ? '0.00' : scope.row.processingCosts-->
<!--                                }}</span>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                    <el-table-column-->
<!--                        width="120px"-->
<!--                        label="总费用">-->
<!--                        <template #default="scope">-->
<!--                            <span>￥{{-->
<!--                                    scope.row.orderPrice === null || scope.row.orderPrice === undefined ? '0.00' : scope.row.orderPrice-->
<!--                                }}</span>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                    <el-table-column
                        width="160px"
                        label="用法">
                        <template #default="scope">
                                <span class="span_con"
                                      :title="scope.row.instructions === null ? '---' : scope.row.instructions">{{
                                        scope.row.instructions === null ? '---' : scope.row.instructions
                                    }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="160px"
                        label="关联药房">
                        <template #default="scope">
                            <span>{{
                                    scope.row.doctorName === '' || scope.row.doctorName === null ? '中药房' : '中药房'
                                }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="160px"
                        label="地址">
                        <template #default="scope">
                                <span class="span_con"
                                      :title="scope.row.receiveDetail === null ? '---' : scope.row.receiveDetail">{{
                                        scope.row.receiveDetail === null ? '---' : scope.row.receiveDetail
                                    }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        width="160px"
                        label="开方时间">
                    </el-table-column>
                    <el-table-column
                        prop="remark"
                        label="备注">
                        <template #default="scope">
                            <div class="span_con" :title="scope.row.remark === null ? '---' : scope.row.remark">
                                {{ scope.row.remark === null ? '---' : scope.row.remark }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="80px">
                        <template #default="scope">
                            <el-tooltip content="详情" placement="bottom">
                                <el-button type="success" icon="MoreFilled" circle
                                           v-on:click="openOrderDetail(scope.row.orderId,scope.row.status)"></el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页-->
            <div class="table_pagination">
                <el-pagination
                    background
                    @size-change="handleOrderSizeChange"
                    @current-change="handleOrderCurrentChange"
                    :current-page="currentPageOrder"
                    :page-size="pageNumsOrder"
                    layout="prev, pager, next, total, sizes"
                    :total="totalCountOrder">
                </el-pagination>
            </div>

        </div>
    </div>

    <!--订单详情-->
    <el-drawer :with-header="false" v-model="orderDetailDialogVisible" :direction="direction" destroy-on-close
               size="36%"
               style="background: #f5f7fa">
        <div class="drawer_con">
            <div class="drawer_title">
                <span>订单详情</span>
                <el-icon class="drawer_icon" @click="orderDetailDialogVisible = false">
                    <close-bold/>
                </el-icon>
            </div>

            <Orderdetail :orderId="orderId"></Orderdetail>
        </div>
    </el-drawer>

</template>

<script>
import order from "@/assets/scripts/order/index";

export default order;
</script>

<style scoped>
@import "@/assets/styles/style.scss";
</style>